import { Component } from '@angular/core';
import { UserProfileComponent as SharedUserProfileComponent } from '@sandbox-platform/shared-ui';

@Component({
  standalone: true,
  imports: [SharedUserProfileComponent],
  selector: 'app-user-profile',
  template: '<sb-user-profile></sb-user-profile>',
})
export class UserProfileComponent {}
